<app-page-header [title]="'Car Class Details'" [subtitle]="'View details of the selected car class'"></app-page-header>
<div class="mb-5">
    <h2>{{ carClass?.name }}</h2>
    <p><strong>ID:</strong> {{ carClass?.id }}</p>
    <p><strong>Label:</strong> {{ carClass?.label }}</p>
    <p><strong>Created By:</strong> {{ carClass?.createdBy | roleName }}</p>
    <p><strong>Updated By:</strong> {{ carClass?.updatedBy | roleName }}</p>
</div>
<div class="flex justify-between gap-2">
    <div>
        <p-button (click)="openEditDialog()" icon="pi pi-pencil" isAdmin label="Edit" text></p-button>
        <p-button (click)="confirmDelete()" icon="pi pi-trash" isAdmin label="Delete" severity="danger" text></p-button>
    </div>
    <p-button label="Back to Car Classes" icon="pi pi-arrow-left" routerLink="/car-classes"></p-button>
</div>

<!-- Update Dialog -->
<app-update-car-class-dialog
        [(visible)]="displayUpdateDialog"
        [carClass]="editableCarClass"
        (carClassUpdated)="reloadCarClassDetails()"
></app-update-car-class-dialog>
